<rl-navbar
  [style.display]="isNavbarVisible ? 'inherit' : 'none'"
  [attr.aria-hidden]="!isNavbarVisible ? true : null"
></rl-navbar>

<rl-lti-relink
  *ngIf="ltiRelinkUrl ? true : false"
  [ltiRelinkUrl]="ltiRelinkUrl"
>
</rl-lti-relink>

<main
  tabindex="-1"
  class="container-fluid"
  [class.is-mobile]="isMobile"
  id="app"
  [attr.data-app-name]="appName"
>
  <router-outlet>
    <rl-loader *ngIf="loading"></rl-loader>
  </router-outlet>
</main>
